import {TinyMCE} from "tinymce";
import { ajaxSpin } from "../../Utils/utils";

declare let tinymce: TinyMCE;

export function receiveDrawitEvent(evt){
    if (evt.origin == 'https://embed.diagrams.net'){
        const message = JSON.parse(evt.data);
        
        switch(message.event){
            case 'init':
                const identifier = document.getElementById("drawio-identifier").value;
                loadEditor(identifier);
                break;

            case 'configure':
                sendConfig();
                break;


            case 'load':
                const size_info = evt.data;
                
                
                break;

            case 'exit':
                exitGraphic();
                break;

            case 'save':
                requestGraphiSave(message.xml);
                break;
            // Message that comes after clicking 'save' and this script requests the png/svg.
            case 'export':
                
                exportGraphic(message.fromat, message.data, message.xml);
                break;

            case 'merge':
                alert("Fehler ist aufgetreten beim Einfügen");
                
                break;

            default:
                alert('Error: Nicht verarbeitbares Event');
                break;
        }
    }
}

function exportGraphic(format, data, xml){
    // const b64 = encodeURIComponent(data);
    const b64 = data;
    xml = encodeURIComponent(xml);
    const identifier = document.getElementById("drawio-identifier").value;
    sendGraphicToServer(b64, xml, identifier);
}

function sendGraphicToServer(b64, xml, identifier){
    const oldIdentifier = identifier;
    const config = {
        url: '/upload-drawit',
        data: {
            xml: xml,
            base64: b64,
            identifier: identifier
        },
        success: function(data){
            console.log(data);
            const insertData = {
                identifier: data.id,
                path: data.image.path,
                oldIdentifier: oldIdentifier, // necessary ?
            }
            tinymce.activeEditor.execCommand('insertGraphic', false, insertData);
            exitGraphic();
        },
        error: function(error){
            errorToast("Konnte nicht gespeichert werden", "Fehler", 0);
        }
    }
    ajaxSpin(config);
}

export function getFrame(){ 
    return document.getElementById("drawio-iframe");
}

function sendConfig(){
    const config = {
        'action': 'configure',
        'config': {
            'pageFormat': {
                'width': 600,
                'height': 600
            },
            'zoomFactor': 0.85,
            'gridSteps': 2,
            'defaultGridEnabled': false,
            'defaultLibraries': 'general;signs',
        }
    }
    sendMessage(config);
}

interface configureMessage {
    action: string,
    config: Object
}

interface loadMsg {
    action: string,
    xml: string,
}

function loadEditor(identifier:string|number){
    if (identifier == 0){
        
        const load_msg = {
            'action': 'load',
            'xml': '',
        }
        loadEditorWithValue(load_msg);
    } else {
        prepareGraphic(identifier);
    }
}

function loadEditorWithValue(loadMsg){
    const frame = getFrame();
    frame.contentWindow.postMessage(JSON.stringify(loadMsg), 'https://embed.diagrams.net')
}

function sendMessage(message){
    const frame = getFrame();
    frame.contentWindow.postMessage(JSON.stringify(message), 'https://embed.diagrams.net')
}


/**
 * 
 * @param pngB64 
 * Soll mal benutzt werden um den Editor zu initialisieren
 */
function insertGraphic(pngB64){
    const message = {
        'action': 'merge',
        'xml': pngB64
    }
    sendMessage(message);
}

function requestGraphiSave(xml){
    const imageMessage = {
        'action': 'export',
        'embedImages': true,
        'format': 'png'
    }
    sendMessage(imageMessage);
}

function prepareGraphic(identifier){
    console.log("HIER");
    // now get the data
    const config = {
        url: '/load-drawit-graphic/' + identifier.toString(),
        data: {
            // action: "editor_graphic_get_svg",
            // identifier: identifier // equals id
        },
        success: function(data){
            const loadMsg = {
                action: 'load',
                xml: data.xml,
            }
            loadEditorWithValue(loadMsg);
        }, 
        error: function(error){
            console.log("ERROR");
        }
    }
    ajaxSpin(config);
}


function exitGraphic(){
    document.getElementById("drawio-iframe").src = '';
    document.getElementById("drawio-modal").style.display = 'none';
}